export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const REFRESH = "refresh";
export const SET_TABLE_DATA = "setTableData";
